/**
 * EventPlanner
 *
 * Purpose: handle planned events stored to the client
 */
var EventPlanner = function() {};
var LOCALSTORAGE_KEY = 'evts_v2';
var HASHIDS_SALT = 'Salar de Uyuni, Bolivia';

EventPlanner.prototype = {
  initialised: false,
  componentsBound : false,
  itemTemplate: '',
  sender : null,
  slider : null,
  visitorLocation : null,
  locationPrompters : null,
  filteringApp : null,
  notifier : null,
  init:  function() {
    this.log('init');
    if(this.plannerHolder().length == 0) {
      throw 'No planner';
    }
    this.setFilteringApp();
    this.plannedItemTemplate();
    this.setScrollbarWidth();
    this.bindComponents();
    return this;
  },

  log : function msg(msg, level) {
    switch(level) {
      case 'error':
        console.error(msg);
        break;
      case 'warning':
        console.warn(msg);
        break;
      default:
        // console.log(msg);
        break;
    }
    return;
  },

  setFilteringApp: function() {
    if(!this.filteringApp) {
      this.filteringApp = document.querySelector('[data-filtering-app]');
    }
  },

  setScrollbarWidth : function() {
    document.documentElement.style.setProperty(
      '--scrollbar-width',
      (window.innerWidth - document.documentElement.clientWidth) + "px"
    );
  },

  plannerHolder : function() {
    return $('#planner-slider');
  },

  plannedItemsHolder : function() {
    return $('#planned-events');
  },

  plannedItems : function() {
    return '.planned-event';
  },

  restoreLink : function() {
    return '#planner-restorelink';
  },

  plannedItemTemplate : function() {
    if(this.itemTemplate != '') {
      return this.itemTemplate;
    }
    var tpl = document.getElementById('planner-template');
    if(tpl) {
      this.itemTemplate = tpl.textContent;
    }
    return this.itemTemplate;
  },

  /**
   * Show elements that need to be seen when there are no events
   * When there are events, do the opposite
   */
  showNoEvents : function() {
    var h = this.plannerHolder();
    if (this.getPlannerCount() == 0) {
      h.addClass('no-events');
      h.find('.no-events-hide').hide().attr('aria-hidden', 'true');
      h.find('.no-events-show').show().attr('aria-hidden', 'false');
    } else {
      h.removeClass('no-events');
      h.find('.no-events-hide').show().attr('aria-hidden', 'false');
      h.find('.no-events-show').hide().attr('aria-hidden', 'true');
    }
  },

  /**
   * Hide elements that should be hidden when there are no events
   * When there are events, do the opposite
   */
  hideNoEvents : function() {
    var h = this.plannerHolder();
    if (this.getPlannerCount() == 0) {
      h.addClass('no-events');
      h.find('.no-events-hide').hide().attr('aria-hidden', 'true');
      h.find('.no-events-show').show().attr('aria-hidden', 'false');
    } else {
      h.removeClass('no-events');
      h.find('.no-events-hide').show().attr('aria-hidden', 'false');
      h.find('.no-events-show').hide().attr('aria-hidden', 'true');
    }
  },

  /**
   * recreate the restore link based on the current planner data
   */
  plannerLink: function(data) {
    if(!data) {
      data = this.getData();
    }
    var ids = [];
    $.each(data, function(id, data) {
      ids.push(id);
    });
    var hashids = new Hashids(HASHIDS_SALT, 8);
    var hash = hashids.encode(ids);
    var link = location.protocol + '//' + location.hostname + $( this.restoreLink() ).data('restore-url') + '/' + hash;
    $( this.restoreLink() ).attr('href', link).show();

    // Sender needs to update its links and actions
    this.sender.setLink( link );
  },

  /**
   * rebuild the planner link and return it
   */
  getRestoreLink: function() {
    this.plannerLink();
    return $( this.restoreLink() ).attr('href');
  },

  /**
   * Escape the value for a RegExp
   * see: http://stackoverflow.com/a/1144788
   */
  escapeRegExp: function(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
  },

  isInPlannerList : function(id) {
    return this.plannedItemsHolder().find(this.plannedItems()).filter('[data-id="'+id+'"]').length > 0;
  },

  appUpdate: function() {
    if(this.filteringApp) {
      try {
        var appName = this.filteringApp.dataset.filteringAppName;
        if(window[appName]) {
          this.log('call app updateFavourites:' +  appName);
          window[appName].updateFavourites();
        }
      } catch (e) {
        console.warn(e);
      }
    }
  },

  /**
   * Add a specific entry to the planner
   */
  addEntry: function(id, eventData) {

    this.log('addEntry=' + id, eventData);

    if(!id) {
      return;
    }

    if(eventData && eventData.id == id) {
      // store the event data
      // remove bound planner data
      delete eventData.plannerBound;
      this.storeEvent(eventData);
    }

    var eventData = this.getEventData(id);

    var _self = this;

    // Update favourite elements for this event
    $('.planner-add[data-id="'+id+'"]').each(
      function() {
        _self.addOnPlannerClasses(this);
      }
    );

    if(!this.isInPlannerList(id)) {
      // add template to list
      var template = this.plannedItemTemplate();
      $.each(
        eventData,
        function(name, value) {
          template = template.replace(
                    new RegExp( _self.escapeRegExp('{{' + name + '}}'), 'g'),
                    value
          );
        }
      );
      var item = $(template);

      // remove button for this item
      item.find('button.remove')
        .addClass('planner-add')
        .addClass('is-on-planner')
        .data('id', eventData['id'])
        .bind(
          'click',
          function(e) {
            _self.removeEntry( $(this).data('id') );
          }
        );

      // workaround: check for empty address
      if(item.children('.address').text() == '') {
        item.children('.address').hide();
      }

      // push element from template into planned items listing
      var plannedItems = this.plannedItemsHolder().children();

      // Insert into empty items list
      if (plannedItems.length <= 0) {
        this.plannedItemsHolder().append(item);
      } else {
        // Insert into correct place in existing list
        var added = false;
        plannedItems.each(
          function() {
            if ($(this).data('sort') > item.data('sort')){
              item.insertBefore($(this));
              added = true;
              return false;
            }
          }
        );

        if (!added){
          this.plannedItemsHolder().append(item);
        }

      }

    }

    this.appUpdate();

    // update the planner count
    this.setPlannerCount();

    // handle no events
    this.hideNoEvents();
    this.showNoEvents();

  },

  /**
   * Update the planner counter
   */
  setPlannerCount : function() {
    $(".planner-count").text( Object.keys(this.getData() ).length );
  },

  /**
   * Get the current count of planner events, as an INT
   */
  getPlannerCount : function() {
    return Object.keys(this.getData()).length;
  },

  /**
   * Remove an entry from the planner
   */
  removeEntry : function(id) {

    this.log('removeEntry', id);
    if (!id) {
      return;
    }

    var _self = this;

    // remove from data
    this.removeEvent(id);

    // Update self and other buttons with the data attributes
    $('.planner-add[data-id="'+id+'"]').each(function() {
      // update all elements with this id
      _self.removeOnPlannerClasses(this);
    });

    // remove elements from planner
    this.plannedItemsHolder().find(this.plannedItems()).filter('[data-id="'+id+'"]').remove();

    // update filtering app
    this.appUpdate();

    // update planner count
    this.setPlannerCount();

    // handle no events
    this.hideNoEvents();
    this.showNoEvents();

  },

  bindComponents: function() {

    this.log('bindComponents');

    if(this.componentsBound) {
      return;
    }

    this.componentsBound = true;

    var _self = this;

    // slider event handling
    this.slider = new EventPlannerSlider();
    this.slider.init().handle();

    // form event handling
    this.sender = new EventPlannerSend();
    this.sender.init().handle();

    this.locationPrompters = this.plannerHolder().find('.prompt-location');
    if(this.locationPrompters.length > 0) {
      // Location handling
      this.visitorLocation = new VisitorLocation();
      // optimistically apply position
      this.visitorLocation.applyPosition();
      this.locationPrompters.bind(
        'click',
        function(e) {
          e.preventDefault();
          try {
            var success = function(position) { _self.log(position); };
            var error = function(position_error) { _self.log(position); };
            var options = {};
            var map;
            var map_options = {};
            _self.visitorLocation.detect(success, error, options, map, map_options, e);
          } catch (e) {
            console.error(e);
          }
        }
      );
    }
  },

  bindEvents: function() {

    this.log('bindEvents');

    var _self = this;
    var data = this.getData();

    this.log( $('.planner-add').length );

    // each event will have a planner-add class, containing event data
    $('.planner-add').each(

      function() {

        _self.log('bindEvent on element');

        if ($(this).data('planner-bound') === true) {
          // already bound to the planner
          _self.log('already bound');
          return;
        }
        var id = $(this).data('id');
        if (!id) {
          // Ignore if not setup properly.
          return;
        }

        _self.log('bind events to element planner-add:' +  id);

        // element bound
        $(this).data('planner-bound', true);

        // bind the addEntry event
        $(this).bind(
          'addEntry',
          function() {
            var id = $(this).data('id');
            _self.addEntry(id, $(this).data());
          }
        );

        // bind the remove entry event
        $(this).bind(
          'removeEntry',
          function() {
            var id = $(this).data('id');
            _self.removeEntry(id);
          }
        );

        // listen for a click event on the element
        $(this).bind(
          'click',
          function(e) {
            e.preventDefault();
            if ($(this).hasClass('is-on-planner')) {
              $(this).trigger('removeEntry');
              _self.notificationRemoveItem();
            } else {
              $(this).trigger('addEntry');
              _self.notificationAddItem();
            }
          }
        );

        // traverse the events found  on initial load
        if(id in data) {
          // add on planner classes
          _self.addOnPlannerClasses(this);
        } else {
          // remove on planner classes
          _self.removeOnPlannerClasses(this);
        }

      }

    );

  }, // end bind events

  getNotifier : function() {
    if(!this.notifier) {
      this.notifier = new Notyf({
        types: [
          {
            type: 'info',
            background: '#da1e4d',
            icon: false
          }
        ],
        ripple : false,
        dismissible : false,
        position : {
          x: 'center',
          y: 'bottom'
        },
        duration : 2000,

      });
    }
    return this.notifier;
  },

  notificationAddItem : function(msg) {
    try {
      this.getNotifier().open({
        type: 'info',
        message: 'Event added to planner'
      });
    } catch(e) {
      console.warn(e);
    }
  },

  notificationRemoveItem:  function(msg) {
    try {
      this.getNotifier().open({
        type: 'info',
        message: 'Event removed from planner'
      });
    } catch(e) {
      console.warn(e);
    }
  },

  addOnPlannerClasses : function(elm) {
    $(elm)
      .addClass('is-on-planner')
      .removeClass('is-not-on-planner');
    try {
      var eventData = $(elm).data();
      var activeIconClass = eventData.activeIcon;
      if(activeIconClass) {
        $(elm).addClass(activeIconClass);
      }
    } catch (e) {
      console.error(e)
    }
  },

  removeOnPlannerClasses : function(elm) {
    $(elm)
      .removeClass('is-on-planner')
      .addClass('is-not-on-planner');
    try {
      var eventData = $(elm).data();
      var activeIconClass = eventData.activeIcon;
      if(activeIconClass) {
        $(elm).removeClass(activeIconClass);
      }
    } catch (e) {
      console.error(e)
    }
  },

  /**
   * returns data keyed by an event id
   */
  getData: function() {
    try {
      var result = store.get(LOCALSTORAGE_KEY) || {};
      return result;
    } catch (e) {
      return {};
    }
  },

  /**
   * returns specific event data based on key
   */
  getEventData: function(id) {
    var data = this.getData();
    return id in data ? data[ id ] : false;
  },

  /**
   * stores event data in local storage, creates a new restore link
   */
  setData: function(data) {
    store.set(LOCALSTORAGE_KEY, data);
    //rebuild the link when data is stored
    this.plannerLink();
  },

  /**
   * add/replace entry to storage
   */
  storeEvent: function(eventData) {
    var data = this.getData();
    data[ eventData.id ] = eventData;
    this.setData(data);
  },

  /**
   * remove index event_id from data
   */
  removeEvent: function(event_id) {
    try {
      var data = this.getData();
      delete data[event_id];
      this.setData(data);
    } catch (e) {
    }
  },

  /**
   * set up planner
   */
  initialisePlanner : function() {
    this.log('called initialisePlanner');
    if(this.initialised) {
      return;
    }
    this.initialised = true;
    if ( this.plannerHolder().length == 0) {
      return;
    }
    var _self = this;
    var data = this.getData();
    if(this.getPlannerCount() > 0) {
      // add each entry to the planner
      $.each(data, function(id, eventData) {
        _self.addEntry(id, eventData);
      });
    }

    this.log( $('.planner-add').length );

    // show the planner count initially
    this.setPlannerCount();

    // hide/show no events
    this.hideNoEvents();
    this.showNoEvents();

    // create the planner link
    this.plannerLink(data);
  }

};

// declare
window.planner = null;
// load up the planner instance
window.addEventListener('DOMContentLoaded', (event) => {
  try {
    window.planner = new EventPlanner();
    window.planner.init();
    window.planner.bindEvents();
    window.planner.initialisePlanner();
  } catch (e) {
    console.warn(e);
  }
});
